const questions = document.querySelectorAll('.melodeon__question');
const answers = document.querySelectorAll('.melodeon__answer');

// Dodajemy event listener do każdego pytania
questions.forEach(question => {
    question.addEventListener('click', melodeonAction);
});

// Funkcja obsługująca akcję melodeonu
function melodeonAction (e) {
    const answer = e.target.closest('div').nextElementSibling;

    // Usuwamy klasy dla wszystkich pytań
    questions.forEach(question => {
        question.classList.remove('melodeon__question--rotated');
        question.parentElement.classList.remove('melodeon__item--active');
    });

    if (answer.clientHeight) {
        // Zamykanie odpowiedzi
        answer.style.height = 0;
        answer.setAttribute('aria-hidden', 'true');
        e.target.closest('div').setAttribute('aria-expanded', 'false');
    } else {
        // Zamykamy wszystkie inne odpowiedzi
        answers.forEach(answer => {
            answer.style.height = '0px';
            answer.setAttribute('aria-hidden', 'true');
        });
        questions.forEach(question => {
            question.setAttribute('aria-expanded', 'false');
        });
        // Otwieramy kliknięte pytanie
        e.target.closest('div').classList.add('melodeon__question--rotated');
        e.target.closest('div').parentElement.classList.add('melodeon__item--active');
        let wrapper = answer.querySelector('.melodeon__text');
        answer.style.height = wrapper.clientHeight + "px";
        answer.setAttribute('aria-hidden', 'false');
        e.target.closest('div').setAttribute('aria-expanded', 'true');
    }
}

// Funkcja do aktualizacji height otwartych elementów przy zmianie rozdzielczości
function updateOpenedHeights() {
    const activeItems = document.querySelectorAll('.melodeon__item--active');
    
    activeItems.forEach(item => {
        const answer = item.querySelector('.melodeon__answer');
        const wrapper = answer.querySelector('.melodeon__text');
        answer.style.height = wrapper.clientHeight + "px";  // Aktualizacja wysokości
    });
}

// Dodajemy listener na zdarzenie resize
window.addEventListener('resize', updateOpenedHeights);

// Ustawiamy wysokość dla już otwartego panelu przez PHP
document.addEventListener('DOMContentLoaded', () => {
    const activeAnswer = document.querySelector('.melodeon__item--active .melodeon__answer');
    if (activeAnswer) {
        let wrapper = activeAnswer.querySelector('.melodeon__text');
        activeAnswer.style.height = wrapper.clientHeight + "px";
    }
});
